import React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

interface RouteErrorBoundaryProps {
  children: React.ReactNode;
  message: string;
}

interface RouteErrorBoundaryState {
  error: Error | null;
}

export default class RouteErrorBoundary extends React.Component<RouteErrorBoundaryProps, RouteErrorBoundaryState> {
  state: RouteErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): RouteErrorBoundaryState {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Stack spacing={1.5}>
        <Alert
          severity="error"
          action={(
            <Button color="inherit" size="small" onClick={() => window.location.reload()}>
              Reload
            </Button>
          )}
        >
          {this.props.message}
        </Alert>
      </Stack>
    );
  }
}
